import cartSlice from "./cart/addCart";
import cartSuccess from "./cart/cartSuccess";
import GetProofRequest from "./presentProof/getProofRequest";
import CreateOOBInvitation from "./outOfBand/createOOBInvitation";
import CreateProofRequest from "./presentProof/createProofRequest";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

const reducer = combineReducers({
  cartSlice,
  cartSuccess,
  CreateProofRequest,
  CreateOOBInvitation,
  GetProofRequest,
});

export default configureStore({
  reducer,
});
